import PiSearchDefaultStroke from "@markeroo/icons/src/stroke/general/PiSearchDefaultStroke";
import PiMultipleCrossCancelDefaultStroke from "@markeroo/icons/src/stroke/maths/PiMultipleCrossCancelDefaultStroke";
import { inputClass } from "@/styles/variants";

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  "aria-label"?: string;
  className?: string;
  autoFocus?: boolean;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "",
  "aria-label": ariaLabel,
  className = "",
  autoFocus = false,
}: SearchInputProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape") {
      onChange("");
      e.currentTarget.blur();
    }
  };

  return (
    <div className={`relative ${className}`}>
      <PiSearchDefaultStroke size={20} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-text-theme-muted" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoFocus={autoFocus}
        className={`${inputClass} pl-10 pr-10`}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-text-theme-muted transition hover:text-text-theme-secondary"
          aria-label="Clear search"
        >
          <PiMultipleCrossCancelDefaultStroke size={20} />
        </button>
      )}
    </div>
  );
}
